//#region ------------ function shorthand -------------------------
var getByID = (element)=>{return document.getElementById(element)}
var getByClass = (element)=>{return document.querySelector('.'+element)}
var getByClassAll = (element)=>{return document.querySelectorAll('.'+element)}
//#endregion ----------------------


btnParking = (e)=>{
  let targetContent = e.getAttribute('content-target');
  getByClassAll('btn-menu-parking').forEach((btn)=>{
    if(btn.getAttribute('content-target') !== targetContent){
      btn.classList.remove('active')
    }else{
      btn.classList.add('active');
    }
  });
  getByClassAll('content').forEach((content)=>{
    content.classList.add('d-none')
  });
  let content = getByID(targetContent);
  content.classList.remove('d-none');
  }

  $('.facebook-share-button').click((e)=>{
    let link = e.target.getAttribute('data-link');
    let dataPopup = e.target.getAttribute('data-popup');
    window.open(link,'popup',dataPopup);
  });

  // $('.media-print-button').click((e)=>{
    // let printContents = document.getElementById('printContent').innerHTML;
    // let originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContents;
    // window.print();
    // document.body.innerHTML = originalContents;
  // });

  $(window).click(function(e) {
    if (e.target.id == 'printBtn') {
      // const printContents = document.getElementById('printContent').innerHTML;
      // const mediaPrint = window.open()
      // const mediaPrintDoc = mediaPrint.document
      // mediaPrintDoc.write(printContents)
      // let originalContents = document.body.innerHTML;
      // document.body.innerHTML = printContents;
    //   setTimeout(()=>{
    //     mediaPrint.print();
    //     mediaPrint.close()
    // }, 1000);
    window.print()
      
      // document.body.innerHTML = originalContents;
    }
});